import React from "react";
import {
  Box,
  SpaceBetween,
  Spinner,
} from "@amzn/awsui-components-react";

import aiAwareBadge from "../../images/raise-badges/ai-aware.png";
import aiEnabledBadge from "../../images/raise-badges/ai-enabled.png";
import aiChampionBadge from "../../images/raise-badges/ai-champion.png";

// Bundled badge art keyed by tier code. (AI Builder is intentionally excluded —
// it isn't one of the three tiers.)
const BADGE_BY_TIER = {
  AI_AWARE: aiAwareBadge,
  AI_ENABLED: aiEnabledBadge,
  AI_CHAMPION: aiChampionBadge,
};

/**
 * Get Certified: one badge per tier. Certifications launch Q4 2026 for AI Aware
 * and AI Enabled. Badge art is bundled and mapped by tier code; a placeholder
 * shows for any tier without a mapped badge.
 */
const GetCertified = ({ certifications, intro }) => {
  if (!certifications) {
    return (
      <Box padding="l">
        <Spinner /> Loading certifications...
      </Box>
    );
  }

  const certs = [...certifications].sort(
    (a, b) => (a.sort_order || 0) - (b.sort_order || 0)
  );

  return (
    <SpaceBetween size="l">
      <div className="raise-cert-callout">
        <span className="raise-cert-pill">Upcoming</span>
        <div className="raise-cert-callout-text">
          {intro || (
            <>
              Certifications will be launched in Q4 2026 for{" "}
              <strong>AI Aware</strong> and <strong>AI Enabled</strong>,
              allowing you to validate your skillset.
            </>
          )}
        </div>
      </div>

      <Box variant="small" color="text-body-secondary">
        One badge per track. These are what you earn when certification opens.
      </Box>

      <div className="raise-cert-badges">
        {certs.map((cert) => {
          const badge = BADGE_BY_TIER[cert.tier_code];
          return (
            <div className="raise-cert-badge" key={cert.certification_id}>
              <div className="raise-cert-badge-art">
                {badge ? (
                  <img
                    src={badge}
                    alt={`${cert.tier_name} certified badge`}
                  />
                ) : (
                  <Box color="text-body-secondary">Badge</Box>
                )}
              </div>
              <div className="raise-cert-badge-name">{cert.tier_name}</div>
              {cert.audience_label && (
                <Box
                  variant="small"
                  textAlign="center"
                  color="text-body-secondary"
                  className="raise-cert-badge-audience"
                >
                  {cert.audience_label}
                </Box>
              )}
            </div>
          );
        })}
      </div>
    </SpaceBetween>
  );
};

export default GetCertified;
